import Head from 'next/head';
import Image from 'next/image';
import Layout from '../../../ui/layout';
import { Wrap, Button } from '../../../styled';
import { TypeformButtonMain } from '../../../components';
import {
  H3,
  Intro,
  DemoInner,
  Testimonials,
  TestimonialsQuote,
  TestimonialsOrigin,
  ChallengeSolution,
  Description,
  DescriptionImage,
  DescriptionText,
  ChallengeSolutionInner,
  ChallengeSolutionCell,
  Motivation,
  MotivationText,
  MotivationImage,
} from '../styled/child';

import intro from './images/intro.jpg';
import logo from './images/logo.svg';
import imac from './images/imac.jpg';
import blacktie from './images/blacktie.png';

const SuccessStoriesBlacktie = () => (
  <Layout>
    <Head>
      <meta name="image" property="og:image" content={intro.src} />
    </Head>
    <Intro>
      <Image src={intro} alt="" fill style={{ objectFit: 'cover' }} />
    </Intro>
    <Wrap>
      <Description>
        <DescriptionImage>
          <Image src={logo} width="392" height="104" alt="Blacktie logo" />
        </DescriptionImage>
        <DescriptionText>
          <p>
            BLACKTIE enables people to own high-quality, stylish, and
            well-fitted tuxedos, suits, and formal accessories for the same
            price as renting one. This way you can always be the star of the
            party, not just for one night.
          </p>
          <p>
            BLACKTIE was founded in 2018 and are now in the scale-up phase.
            Customers love them (rated 4.8 out of 5 based on 3,000+ reviews);
            and now it’s time to scale further and extend their audience.
          </p>
          <p>
            Brides & grooms shouldn’t have to settle for a used hand-me-down
            garment on one of the most important days of their lives. BLACKTIE’s
            main purpose is that guys can be confident and feel like they “own
            the room” on their special day.
          </p>
        </DescriptionText>
      </Description>
    </Wrap>
    <ChallengeSolution>
      <Wrap>
        <ChallengeSolutionInner>
          <ChallengeSolutionCell>
            <H3>The Challenge</H3>
            <p>
              BLACKTIE launched their website in 2018. At that time they noticed
              that customers loved the styling of their products, but one of the
              main concerns was answering the question “What size should I
              take?”
            </p>
            <p>
              It appeared that the current size chart on the BLACKTIE website
              wasn’t fully answering these questions, as they took a lot of time
              to answer.
            </p>
            <p>
              Instead, they started looking for a tool that could help ease
              people’s minds when it comes to sizing.
            </p>
          </ChallengeSolutionCell>
          <ChallengeSolutionCell>
            <H3>The Solution</H3>
            <p>
              EyeFitU offered a SizeFinder, allowing customers to receive
              recommendations by answering a few basic questions about
              themselves.
            </p>
            <p>
              At the same time, customers can immediately see how the clothes
              and the different sizes will fit their body: wide, tight or
              normal. This way, the customer gets personalized advice around the
              size that suits their body best, and as a result helps them make
              the right decision.
            </p>
          </ChallengeSolutionCell>
        </ChallengeSolutionInner>
      </Wrap>
    </ChallengeSolution>
    <Wrap>
      <Motivation>
        <MotivationText>
          <H3>Why EyeFitU?</H3>
          <p>
            EyeFitU had a clean visual widget which allowed users to get
            accurate sizing recommendations. In the backend, it helps BLACKTIE
            to map their garment’s individual measurements to EyeFitU’s sizing
            algorithm. Once completed, we had a useful tool that customers could
            use whem selecting their formal wear.
          </p>
        </MotivationText>
        <MotivationImage>
          <Image src={imac} width="483" height="543" alt="" />
        </MotivationImage>
      </Motivation>
    </Wrap>
    <Testimonials>
      <Wrap>
        <Image src={blacktie} width="192" height="192" alt="Blacktie logo" />
        <TestimonialsQuote>
          “EyeFitU was very helpful and responsive during the evaluation stage
          and onboarding. They did everything to give us a great kickstart!”
        </TestimonialsQuote>
        <TestimonialsOrigin>— Christopher Cardi, CEO</TestimonialsOrigin>
      </Wrap>
    </Testimonials>
    <Wrap>
      <DemoInner>
        <div>
          <H3>Book a Meeting</H3>
          <Button as={TypeformButtonMain}>Let’s talk</Button>
        </div>
      </DemoInner>
    </Wrap>
  </Layout>
);

export default SuccessStoriesBlacktie;
